<template>
	<div class="header-mobile">
		<img :src="COMPANY_LOGO" alt="" class="mobile-logo" />
		<MobileMenu ref="selfMobileRef"></MobileMenu>
	</div>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { COMPANY_LOGO } from '@/const/host';
import MobileMenu from '@/views/layout/components/mobile-menu.vue';

const selfMobileRef = ref();
const hide = () => {
	selfMobileRef.value?.hide();
};

defineExpose({
	hide
});
</script>

<style lang="less" scoped>
.header-mobile {
	width: 100%;
	background-color: rgba(16, 23, 41, 0.88);
	height: 5.5rem;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	-ms-flex-pack: justify;
	justify-content: space-between;
	padding: 1.55rem;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999;

	.mobile-logo {
		display: block;
		width: 6rem;
		height: 1.5rem;
	}
}
</style>
